import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Budgetcorporatecabservice() {



  const cardData =
  {
    keyword: 'Budget Corporate Cab Services in Kolkata',
    heading: 'Aaryan Travels: Budget Corporate Cab Services in Kolkata',
    headingDescription: ' Aaryan Travels provides Budget Corporate Cab Services in Kolkata for companies, factories, and professionals who require reliable transportation without overspending. Whether it’s employee commute, client pickups, airport transfers from Netaji Subhas Chandra Bose International Airport, or intercity business travel to Durgapur, Siliguri, or Ranchi, our fleet of sedans, SUVs, and tempo travellers ensures a smooth journey at economical rates. With disciplined chauffeurs, GPS-enabled vehicles, transparent billing, and monthly rental options, we deliver cost-effective corporate mobility solutions across key business zones like Salt Lake, New Town, Park Street, and Howrah. Aaryan Travels is the trusted partner for budget-friendly corporate cab services in Kolkata that balance affordability with professionalism.',

    top: 'Top Places to Visit in Kolkata with Aaryan Travels',

 "topPlaces": [
  {
    "title": "Victoria Memorial",
    "description": "Built in memory of Queen Victoria, the Victoria Memorial is a grand marble monument surrounded by lush gardens. The museum inside showcases paintings, manuscripts, and artifacts from the British era. Illuminated at night, it creates a majestic sight. The surrounding lawns are popular for evening strolls and picnics. Victoria Memorial is Kolkata’s enduring symbol of elegance and colonial heritage."
  },
  {
    "title": "Howrah Bridge (Rabindra Setu)",
    "description": "Howrah Bridge is an engineering marvel built without nuts or bolts, connecting Kolkata to Howrah across the Hooghly River. It is one of the busiest cantilever bridges in the world with constant pedestrian and vehicular movement. Lit up beautifully at night, it becomes a stunning landmark. Watching ferries pass beneath is a soothing experience. Howrah Bridge is Kolkata’s iconic gateway of strength and unity."
  },
  {
    "title": "Dakshineswar Kali Temple",
    "description": "Dakshineswar Kali Temple, located along the Hooghly River, is dedicated to Goddess Bhavatarini, a form of Kali. It is historically associated with the revered saint Sri Ramakrishna Paramahamsa. Pilgrims throng the temple, especially during festivals. The peaceful ghats and river views enhance the spiritual atmosphere. Dakshineswar Temple is Kolkata’s sacred seat of devotion and faith."
  },
  {
    "title": "Belur Math",
    "description": "Belur Math is the global headquarters of the Ramakrishna Mission, founded by Swami Vivekananda. Its architecture uniquely blends Hindu, Buddhist, and Christian styles to symbolize religious unity. The serene riverside setting is ideal for meditation and reflection. The evening prayer chants are soul-stirring. Belur Math is Kolkata’s beacon of peace and harmony."
  },
  {
    "title": "Park Street",
    "description": "Park Street is Kolkata’s most vibrant entertainment and dining hub, lined with historic restaurants, jazz pubs, and bakeries. Famous eateries like Flurys and Peter Cat attract food lovers year-round. During Christmas and New Year, the entire street glows with festive lights. Music, food, and nightlife come together effortlessly. Park Street is Kolkata’s avenue of celebration."
  },
  {
    "title": "Indian Museum",
    "description": "Founded in 1814, the Indian Museum is the oldest and largest museum in India. It houses ancient sculptures, mummies, fossils, and Mughal paintings. Each gallery reveals a treasure of history and science. The dinosaur skeletons are a popular highlight among visitors. Indian Museum is Kolkata’s treasure trove of heritage and knowledge."
  },
  {
    "title": "St. Paul’s Cathedral",
    "description": "St. Paul’s Cathedral is a stunning Gothic-style church with beautifully carved interiors and stained-glass windows. The tranquil ambiance makes it an ideal spot for reflection. Built in 1847, it stands as a legacy of colonial architecture. Its lawn and facade are especially picturesque during Christmas. St. Paul’s Cathedral is Kolkata’s elegant landmark of faith."
  },
  {
    "title": "Science City",
    "description": "Science City is India’s largest science museum featuring interactive exhibits, space theaters, ropeways, and illusion tunnels. Visitors enjoy hands-on learning while exploring physics, biology, and robotics sections. The 3D shows and Earth exploration zone are major attractions. Science City is Kolkata’s futuristic hub of education and entertainment."
  },
  {
    "title": "Kalighat Temple",
    "description": "Kalighat Temple is one of the 51 Shakti Peethas dedicated to Goddess Kali, attracting thousands of devotees daily. The temple’s sanctum is small but powerful in spiritual energy. Nearby markets sell puja items and traditional artwork. Despite the crowds, the devotion remains intense. Kalighat Temple is Kolkata’s deep-rooted spiritual heart."
  },
  {
    "title": "Eco Park (Prakriti Tirtha)",
    "description": "Eco Park is a massive urban park featuring themed gardens, lakes, and adventure sports. Visitors enjoy boating, cycling, and relaxing in Japanese and bamboo gardens. Replica world monuments like the Eiffel Tower and pyramids make it photo-worthy. It is perfect for families and fitness enthusiasts. Eco Park is Kolkata’s green paradise of recreation."
  }
],


"services": [
  {
    "name": "Budget Corporate Cab Services in Kolkata",
    "description": "Our Budget Corporate Cab Services in Kolkata provide businesses with affordable yet reliable transportation options designed to meet diverse corporate travel needs. Whether you need daily employee pickups, client meetings, or event transportation, our cost-effective solutions combine quality vehicles with professional chauffeurs to ensure timely and comfortable journeys. We offer customizable plans that help companies optimize travel budgets without compromising on safety or service standards, making us a preferred choice for startups, SMEs, and large enterprises."
  },
  {
    "name": "Affordable Business Taxi Kolkata",
    "description": "Affordable Business Taxi Kolkata offers dependable taxi services tailored specifically for corporate clients who want to maintain efficiency while managing costs. Our fleet includes well-maintained sedans and SUVs, driven by courteous and experienced drivers. Whether for airport transfers, client visits, or interoffice travel, we ensure prompt arrivals and smooth rides, supporting your business’s daily transportation demands."
  },
  {
    "name": "Kolkata Corporate Cab Hire",
    "description": "Kolkata Corporate Cab Hire specializes in flexible vehicle rental solutions for companies of all sizes. Our services include short-term and long-term rentals with professional chauffeurs who understand corporate etiquette and prioritize punctuality. From executive trips to employee shuttles, we provide comfortable, clean vehicles with transparent billing to suit your organizational requirements."
  },
  {
    "name": "Cost Effective Corporate Cab Kolkata",
    "description": "Cost Effective Corporate Cab Kolkata delivers budget-friendly corporate transportation without compromising service quality. Designed to support businesses aiming to optimize expenses, our offerings include route planning, GPS tracking, and timely pickups. We cater to daily office commutes, client meetings, and event transportation with a strong focus on safety and reliability."
  },
  {
    "name": "Employee Transport Kolkata",
    "description": "Employee Transport Kolkata provides comprehensive solutions for staff commute across multiple shifts and locations. Our well-coordinated services include route optimization, verified drivers, and real-time vehicle tracking to ensure employee safety and punctuality. We help reduce absenteeism and improve operational efficiency by offering comfortable and timely transport for your workforce."
  },
  {
    "name": "Office Cab Kolkata",
    "description": "Office Cab Kolkata offers reliable daily transportation services tailored to office employees. Our services include fixed routes, flexible scheduling, and easy booking options to reduce the hassle of staff commute. With clean vehicles and trained drivers, we ensure a smooth and stress-free ride for your team, enhancing productivity and attendance."
  },
  {
    "name": "Low Budget Corporate Taxi Kolkata",
    "description": "Low Budget Corporate Taxi Kolkata provides economical corporate taxi services for businesses looking to minimize transportation costs. Our fleet of fuel-efficient cars and friendly drivers ensures that your staff and executives travel safely and punctually across the city, making this service perfect for budget-conscious organizations."
  },
  {
    "name": "Corporate Chauffeur Kolkata",
    "description": "Corporate Chauffeur Kolkata offers premium chauffeur-driven services for executives and VIP clients. Our drivers are professionally trained to provide courteous, discreet, and punctual service, ensuring a seamless travel experience. Ideal for business meetings, client visits, and corporate events, we prioritize comfort and professionalism in every ride."
  },
  {
    "name": "Corporate Car Rental Kolkata",
    "description": "Corporate Car Rental Kolkata delivers flexible vehicle rental options tailored to corporate travel needs. Whether you require sedans, SUVs, or premium cars with or without chauffeurs, our service is designed to accommodate daily commutes, outstation travel, and special events, all with competitive pricing and reliable support."
  },
  {
    "name": "Corporate Travel Cab Kolkata",
    "description": "Corporate Travel Cab Kolkata specializes in providing efficient and comfortable transportation solutions for business trips and client visits. Our service ensures punctuality, safety, and professionalism, with a fleet equipped to handle short city trips as well as long-distance travel, making corporate journeys hassle-free."
  },
  {
    "name": "Staff Cab Kolkata",
    "description": "Staff Cab Kolkata is focused on delivering dependable transportation services for your entire workforce. Our fleet includes a variety of vehicles suited to different team sizes, with professional drivers ensuring timely pickups and drop-offs. We customize routes and schedules to meet your company's unique transport requirements."
  },
  {
    "name": "Corporate Cab Deals Kolkata",
    "description": "Corporate Cab Deals Kolkata offers exclusive packages designed to provide cost savings and flexible booking options for businesses. Whether you need daily transportation or occasional cab services for events, our deals include fixed pricing, priority customer support, and scalable fleet options to suit your corporate travel demands."
  },
  {
    "name": "Corporate Event Cab Kolkata",
    "description": "Corporate Event Cab Kolkata provides specialized transportation services for business conferences, seminars, and corporate gatherings. We manage group transfers with punctuality and professionalism, using a fleet of well-maintained vehicles and experienced chauffeurs to ensure a smooth and comfortable experience for all attendees."
  },
  {
    "name": "Reliable Corporate Cab Kolkata",
    "description": "Reliable Corporate Cab Kolkata is committed to delivering consistent, safe, and efficient transportation solutions for corporate clients. Our focus on vehicle maintenance, driver training, and customer satisfaction makes us a trusted partner for your business travel needs across Kolkata."
  },
  {
    "name": "Budget Office Cab Kolkata",
    "description": "Budget Office Cab Kolkata offers affordable and efficient office commute solutions designed to help businesses reduce transportation expenses while ensuring employee comfort and punctuality. Our services include daily pick-up and drop, flexible timings, and easy booking processes, making us a practical choice for office transportation."
  }
],
"tableData": [
  ["Budget Corporate Cab Services in Kolkata", "Affordable Business Taxi Kolkata"],
  ["Kolkata Corporate Cab Hire", "Cost Effective Corporate Cab Kolkata"],
  ["Employee Transport Kolkata", "Office Cab Kolkata"],
  ["Low Budget Corporate Taxi Kolkata", "Corporate Chauffeur Kolkata"],
  ["Corporate Car Rental Kolkata", "Corporate Travel Cab Kolkata"],
  ["Staff Cab Kolkata", "Corporate Cab Deals Kolkata"],
  ["Corporate Event Cab Kolkata", "Reliable Corporate Cab Kolkata"],
  ["Budget Office Cab Kolkata", "—"]
],

"whychoose": [
  {
    "WhyChooseheading": "Budget Corporate Cab Services in Kolkata",
    "WhyChoosedescription": "Aaryan Travels provides affordable and reliable corporate cab services designed to meet the budget needs of businesses in Kolkata."
  },
  {
    "WhyChooseheading": "Timely and Efficient Pickup and Drop",
    "WhyChoosedescription": "Ensure punctual transportation for your employees and clients across Kolkata without compromising quality."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles for Business Travel",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs maintained to deliver a professional and comfortable experience."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Kolkata’s Corporate Routes",
    "WhyChoosedescription": "Our drivers have in-depth knowledge of the city to provide smooth and efficient rides."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "Benefit from upfront pricing and GST-compliant invoices with no hidden charges."
  },
  {
    "WhyChooseheading": "24/7 Dedicated Customer Support",
    "WhyChoosedescription": "Our support team is available around the clock to assist with bookings, cancellations, and queries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans Tailored to Business Needs",
    "WhyChoosedescription": "Choose from daily, weekly, or monthly contracts customized to your company’s budget and requirements."
  },
  {
    "WhyChooseheading": "Wide Fleet of Vehicles to Suit Your Team Size",
    "WhyChoosedescription": "Select from sedans, SUVs, and tempo travellers based on your comfort and luggage preferences."
  }
]






























  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer budget corporate cab services in Kolkata?',
    answer: 'Yes, Aaryan Travels provides affordable and budget-friendly corporate cab services across Kolkata tailored for business travel.',
  },
  {
    question: 'How can I book budget corporate cab services in Kolkata with Aaryan Travels?',
    answer: 'You can book easily through our website, mobile app, or by contacting our corporate support team.',
  },
  {
    question: 'What types of vehicles are available for budget corporate cab services in Kolkata?',
    answer: 'Aaryan Travels offers a variety of budget-friendly vehicles including sedans and economy cars suitable for corporate use.',
  },
  {
    question: 'Are budget corporate cab services suitable for daily employee commute in Kolkata?',
    answer: 'Yes, we provide customized budget corporate cab solutions for daily employee pickups and drops across Kolkata.',
  },
  {
    question: 'Are drivers experienced and trained for corporate travel requirements in Kolkata?',
    answer: 'Absolutely. Our drivers are professionally trained, courteous, and familiar with corporate travel standards in Kolkata.',
  },
  {
    question: 'Can Aaryan Travels handle bulk or group budget corporate cab bookings in Kolkata?',
    answer: 'Yes, we manage group transportation and bulk bookings for corporate meetings, events, and conferences efficiently.',
  },
  {
    question: 'Do you offer monthly billing or invoice options for budget corporate cab services in Kolkata?',
    answer: 'Yes, flexible billing options including monthly invoicing are available for our corporate clients.',
  },
  {
    question: 'Is budget corporate cab service available 24x7 in Kolkata?',
    answer: 'Yes, Aaryan Travels offers round-the-clock budget corporate cab services in Kolkata to ensure seamless business travel.',
  },
  {
    question: 'What safety measures are in place for budget corporate cab services in Kolkata?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict safety protocols to ensure passenger safety.',
  },
  {
    question: 'Can pickup and drop-off locations be customized for budget corporate cab bookings in Kolkata?',
    answer: 'Yes, full customization of pickup and drop points is available based on your corporate travel needs.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anirban Das',
    feedback: 'Aaryan Travels offers excellent budget corporate cab services in Kolkata with professional drivers and timely service.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Ritu Sen',
    feedback: 'Reliable and affordable corporate cab options in Kolkata. Highly recommend Aaryan Travels for budget corporate travel.',
    rating: 5,
  },
];


















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Budget Corporate Cab Services in Kolkata",
  "image": "https://aaryantravels.com/assets/images/budget-corporate-cab-kolkata.jpg", // replace with actual image URL
  "description": "Aaryan Travels provides budget-friendly corporate cab services in Kolkata, including affordable business taxis, employee transport, and reliable corporate chauffeur services.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.6", // example rating
    "ratingCount": "2500", // example rating count
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1100", // example price
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/budget-corporate-cab-services-kolkata"
  }
};










  return (
    <div>
<Helmet>
  <title>Budget Corporate Cab Services in Kolkata | Affordable Business Taxi | Aaryan Travels</title>
  <meta
    name="description"
    content="Find budget corporate cab services in Kolkata with Aaryan Travels. Affordable business taxis, employee transport, and corporate chauffeur services at low prices."
  />
  <meta
    name="keywords"
    content="Budget Corporate Cab Services in Kolkata, Affordable Business Taxi Kolkata, Kolkata Corporate Cab Hire, Cost Effective Corporate Cab Kolkata, Employee Transport Kolkata, Office Cab Kolkata, Low Budget Corporate Taxi Kolkata, Corporate Chauffeur Kolkata, Corporate Car Rental Kolkata, Corporate Travel Cab Kolkata, Staff Cab Kolkata, Corporate Cab Deals Kolkata, Corporate Event Cab Kolkata, Reliable Corporate Cab Kolkata, Budget Office Cab Kolkata"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/45.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Budgetcorporatecabservice;